import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { concat, EMPTY, first, map, switchMap } from 'rxjs';

import { BaseHomePageService } from '@locumsnest/auth/src/lib/session-auth/services/home-page.service';
import { IHomePageService } from '@locumsnest/auth/src/lib/session-auth/services/interfaces';
import { HOME_PAGE } from '@locumsnest/auth/src/lib/session-auth/services/opaque-tokens';

import { AuthGroupService } from '../../../auth-group/+state/auth-group.service';

@Injectable({
  providedIn: 'root',
})
export class HomePageService extends BaseHomePageService implements IHomePageService {
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  private authGroupService = inject(AuthGroupService);
  private store = inject(Store);
  private homePage = inject(HOME_PAGE);

  getHomeUrl() {
    return concat(
      this.authGroupService.load().pipe(
        switchMap((action) => {
          this.store.dispatch(action);
          return EMPTY;
        }),
      ),
      this.getMainMicroApp().pipe(
        map((microApp) => {
          if (microApp) return microApp.basePath;
          return this.homePage;
        }),
      ),
    );
  }

  getMainMicroApp() {
    return this.authGroupService.getCurrentGroupMicroAppConfiguration().pipe(first());
  }
}
